enum AppEnv {
  PRODUCTION = 'production',
  TEST = 'test',
  STAGING = 'staging',
  STAGING2 = 'staging2',
}

export default AppEnv;
